import type {SuggestiveSellingOfferPayload, SuggestiveSellingTarget} from '../types';

export function getQuoteModalPendingKey(partId: number): string {
    return `quote-modal:${partId}`;
}

export function getQuoteOrderPendingKey(orderId: number): string {
    return `quote:${orderId}`;
}

export function getShoppingCartPendingKey(userId: number): string {
    return `shoppingCart:${userId}`;
}

export function getQuickOrderPartPendingKey(partNumber: string): string {
    return `quickOrder:${partNumber.toUpperCase().trim()}`;
}

export function getSuggestiveSellingPendingKey(
    payload: Pick<SuggestiveSellingOfferPayload, 'sourcePartId' | 'sourcePartNumber' | 'target'> & {
        pendingKey?: string;
    },
): string {
    if (payload.pendingKey) {
        return payload.pendingKey;
    }

    const {target, sourcePartId, sourcePartNumber} = payload;

    switch (target.type) {
        case 'quickOrder':
            return getQuickOrderPartPendingKey(sourcePartNumber);
        case 'quote':
            return getQuoteOrderPendingKey(target.orderId);
        case 'shoppingCart':
            return getShoppingCartPendingKey(target.userId);
        default: {
            const exhaustive: never = target;
            return `${(exhaustive as SuggestiveSellingTarget).type}:${sourcePartId}`;
        }
    }
}
